export const boardHeadText = ['No.', '제목', '작성자', '작성일자'];
